module.exports = __webpack_public_path__ + "img/new0yuan.f5135c7f.png";